import React from 'react'
import { Card, Dropdown, Row, Col, Badge } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { toCapitalize } from '../../../resources/Utils'

export default (props) => {
    const { action, merchantId } = props.match.params;

    return (
      <>
      {action === 'view' && 
      
      <Row className="mx-auto card-width-1200 mt-4">
        <Col sm={{span:2, offset:10}} className="p-0 text-right">
          <Dropdown alignRight>
            <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic">
              <span> Action</span>
            </Dropdown.Toggle>
              <Dropdown.Menu>
                  <Dropdown.Item
                      as={Link}
                      to={{
                          pathname:"/merchant/update",
                          }}
                  >
                    Edit
                  </Dropdown.Item>
              </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>
      }
      </>
    )
  }